import { Injectable } from '@angular/core';
import { Filter } from '../models/filter.model';
import { SingleValueFilterOption } from '../models/singlevaluefilteroption.model';
import { FilterOption } from '../interfaces/filteroption.interface';
import { RangeFilterOption } from '../models/rangefilteroption.model';

@Injectable()
export class FilterSortService {
  public static compareRangeStart(
    filterOptionA: RangeFilterOption,
    filterOptionB: RangeFilterOption,
  ): number {
    if (
      typeof filterOptionA.rangeStart === 'undefined' &&
      typeof filterOptionB.rangeStart === 'undefined'
    ) {
      return 0;
    } else if (typeof filterOptionA.rangeStart === 'undefined') {
      return -1;
    } else if (typeof filterOptionB.rangeStart === 'undefined') {
      return 1;
    } else {
      return filterOptionA.rangeStart - filterOptionB.rangeStart;
    }
  }

  public static compareRangeEnd(
    filterOptionA: RangeFilterOption,
    filterOptionB: RangeFilterOption,
  ): number {
    if (
      typeof filterOptionA.rangeEnd === 'undefined' &&
      typeof filterOptionB.rangeEnd === 'undefined'
    ) {
      return 0;
    } else if (typeof filterOptionA.rangeEnd === 'undefined') {
      return 1;
    } else if (typeof filterOptionB.rangeEnd === 'undefined') {
      return -1;
    } else {
      return filterOptionA.rangeEnd - filterOptionB.rangeEnd;
    }
  }

  public sort(filters: Filter[]): void {
    filters.forEach((filter: Filter) => {
      // Sort the Filter options
      filter.options.sort(
        (filterOptionA: FilterOption, filterOptionB: FilterOption) => {
          if (
            filterOptionA instanceof SingleValueFilterOption &&
            filterOptionB instanceof SingleValueFilterOption
          ) {
            return this.sortSingleValueFilterOption(
              filterOptionA,
              filterOptionB,
            );
          } else if (
            filterOptionA instanceof RangeFilterOption &&
            filterOptionB instanceof RangeFilterOption
          ) {
            return this.sortRangeFilterOption(filterOptionA, filterOptionB);
          } else {
            return 0;
          }
        },
      );
    });
  }

  public sortSingleValueFilterOption(
    filterOptionA: SingleValueFilterOption,
    filterOptionB: SingleValueFilterOption,
  ): number {
    let compareFilter = filterOptionB.count - filterOptionA.count;

    // If the count is the same, order by alphabet
    if (compareFilter === 0) {
      compareFilter = filterOptionA.label.localeCompare(filterOptionB.label);
    }
    return compareFilter;
  }

  public sortRangeFilterOption(
    filterOptionA: RangeFilterOption,
    filterOptionB: RangeFilterOption,
  ): number {
    let compare = FilterSortService.compareRangeStart(
      filterOptionA,
      filterOptionB,
    );
    if (compare === 0) {
      compare = FilterSortService.compareRangeEnd(filterOptionA, filterOptionB);
    }
    return compare;
  }
}
